import AutocompleteFormField from './autocomplete_form_field';

export default class RadioFormField extends AutocompleteFormField {
	constructor(fieldProps = {}) {
		super(fieldProps);
	}
}
